import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  footerNavigationItems: []
}

const footerSlice = createSlice({
  name: "footerNavigation",
  initialState,
  reducers: {
    fetchData: (state, action) => {
      state.footerNavigationItems = action.payload.footerNavigation
    }
  }
})

// Export the action
export const { fetchData } = footerSlice.actions

// Export the reducer
export default footerSlice.reducer
